export const SET_IN_PROGRESS_PROJECT = 'SET_IN_PROGRESS_PROJECT';

export const setInProgressProject = (inProgressProject) => ({
    inProgressProject,
    type: SET_IN_PROGRESS_PROJECT,
});